// IMPORT REACT
import React from 'react';
import Axios from 'axios';

// IMPORT COMPONENTS
import YAText from '../Text';
import YAContainer from '../Grid/Container';
import YARow from '../Grid/Row';
import YAColumn from '../Grid/Column';
import YAButton from '../Form/Button';

// IMPORT STYLES
import { SC_Footer, SC_FooterText, SC_FooterLink } from './styles';



class YAFooter extends React.Component {

	state = {
		home: null,
		terms: null,
		privacy: null,
		bloginfo: this.props.bloginfo
  }

  componentDidMount() {
    this.getPage('home,terms-of-use,privacy-policy', this.props.lang).then(data => {
      if(data && data[0]){
        this.setState({
					home : data[0],
					terms : data[1] ? data[1] : null,
					privacy : data[2] ? data[2] : null,
        },function(){          
          
        })      
      } else {
        console.log('Error occured, unable to get home page');
			}
			if(!this.state.bloginfo){
				this.getBloginfo(this.props.lang).then(data => {
					this.setState({
						bloginfo : data
					},function(){          
						
					})  
				});
			}
    });
	}
	
	getBloginfo(lang){
    let url = '/wp-json/wp/v2/weemarkable/bloginfo/'; 
    url += '?lang=';
    url += lang;
    let self = this;
    return Axios({
      method: 'get',
      url: url
    }).then((response)=>{
      return response.data;
    }).catch(function(error){
      console.log(error, 'Error');
    });  
  }

  getPage(page_name,lang){
    let url = '/wp-json/wp/v2/weemarkable/pages/'; 
    url += '?post_type=page&post_name=';
		url += page_name;
		url += '&lang=';
    url += lang;
    let self = this;
    return Axios({
      method: 'get',
      url: url
    }).then((response)=>{
      if(response.data[0]){
        return response.data;
      } else {
        console.log(response, 'Error');
			}
    }).catch(function(error){
      console.log(error, 'Error');
    });  
	}
	
	render(){
		const bloginfo = this.state.bloginfo;
		const homemeta = this.state.home ? this.state.home['meta'] : null;
		const terms = this.state.terms;
		const privacy = this.state.privacy;

    return (
    	<SC_Footer>
				<YAContainer>
					<YARow>
						<YAColumn textAlign="center">
							<YAButton to={privacy ? privacy.permalink : '#'} color="link" bootstrap="text-muted">
								{privacy ? privacy.post_title : null}
							</YAButton>
							<YAButton to={terms ? terms.permalink : '#'} color="link" bootstrap="text-muted">
								{terms ? terms.post_title : null}
							</YAButton>
							<YAButton href={homemeta ? homemeta.footer_contact_button_link : '#'} color="link" bootstrap="text-muted">
								{homemeta ? homemeta.footer_contact_button_text : null}
							</YAButton>
						</YAColumn>
					</YARow>
					<hr/><br/>
					<YARow>
						<YAColumn size="col-lg-4">
							
							<YAText>
								{homemeta ? homemeta.footer_trademark_text : null}
							</YAText>
							<SC_FooterText>
								
									&copy; {(new Date().getFullYear())} <YAText tag="span">{bloginfo ? bloginfo.name : null}</YAText> 
								
							</SC_FooterText>
							
						</YAColumn>
						<YAColumn size="col-xl-4 col-lg-5 offset-xl-4 offset-lg-3" textAlignMinLg="right">
							
							<YAText>
								{homemeta ? homemeta.footer_funding_text : null}
							</YAText>

						</YAColumn>
					</YARow>
				</YAContainer>
    	</SC_Footer>
    )
	}
}
export default YAFooter;